export default "__VITE_ASSET__BbYsKQYP__"